import { TopNavLink, TopNavLinkSection } from '../components/top-nav/types';

/** Section rendered as a single anchor (no expandable link panel). */
export function getSoleLink(section: TopNavLinkSection | undefined | null): TopNavLink | null {
  if (!section) return null;
  return Array.isArray(section.links) && section.links.length === 1 ? section.links[0] : null;
}

export function isSoleLinkSection(section: TopNavLinkSection | undefined | null): boolean {
  return getSoleLink(section) !== null;
}

export function sectionHasExpandablePanel(section: TopNavLinkSection): boolean {
  return !isSoleLinkSection(section);
}
